module.exports = __webpack_public_path__ + "static/media/sweeps.85779e1c.png";